module.exports = __webpack_public_path__ + "static/media/coupons.ef529f2b.svg";